/**
 * What: Shared merchant-goal vocabulary and optional context consumed by Shopify Product Opportunity.
 * Transport / data-flow: Projects saved merchant answers into generation when present; this context
 * is optional and never a generation prerequisite.
 */
import * as z from 'zod';
export const merchantStoreGoalIds = [
    'win_first_orders',
    'bring_buyers_back',
    'grow_basket',
    'hold_price',
    'stand_out',
];
export const merchantStoreGoalIdSchema = z.enum(merchantStoreGoalIds);
export const SHOPPER_OPPORTUNITY_MERCHANT_CONTEXT_SCHEMA_ID = 'shopper-opportunity-merchant-context.v1';
export const SHOPPER_OPPORTUNITY_MERCHANT_BRIEF_READ_REQUEST_SCHEMA_ID = 'shopper-opportunity-merchant-brief-read.request.v1';
/** Signed Shopify-to-Web read scope for the connection-owned merchant brief. */
export const shopperOpportunityMerchantBriefReadRequestSchema = z.strictObject({
    externalAccountId: z.string().trim().min(1),
    connectionId: z.string().trim().min(1).optional(),
});
export const shopperOpportunityMerchantContextSchema = z
    .strictObject({
    schemaVersion: z.literal(SHOPPER_OPPORTUNITY_MERCHANT_CONTEXT_SCHEMA_ID),
    source: z.literal('org_merchant_attributes'),
    questionnaireVersion: z.number().int().positive(),
    businessDescription: z.string().trim().min(10).max(2_000).optional(),
    primaryGoal: merchantStoreGoalIdSchema.optional(),
})
    .refine((context) => context.businessDescription !== undefined || context.primaryGoal !== undefined);
//# sourceMappingURL=shopper-opportunity-merchant-context.js.map